import React from 'react';
import PropTypes from 'prop-types';

import { FormControl, InputLabel, Input, InputAdornment } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import IconArrowDropDown from '@material-ui/icons/ArrowDropDown';

import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles/index';

const styles = {
  input: {
    background: '#f2f2f2',
    padding: '1rem',
    fontSize: '1.5rem',
    lineHeight: '2.5rem',
    color: '#222',
    fontWeight: '300',
  },
};

const CurrencySelectField = ({
  classes, onChange, onClick, currency, id, label,
}) => (
  <FormControl
    className={classNames(classes.margin, classes.textField)}
    fullWidth
    style={{ cursor: 'pointer' }}
  >
    <InputLabel>{label}</InputLabel>
    <Input
      classes={{ input: classes.input }}
      inputProps={{ tabIndex: -1 }}
      style={{ backgroundColor: '#f2f2f2', cursor: 'pointer' }}
      onClick={onClick}
      onChange={onChange}
      id={id}
      value={currency.label}
      fullWidth
      startAdornment={
        <InputAdornment position="end" style={{ minWidth: '25px', paddingTop: '1.25rem', paddingRight: '1rem' }}>
          <img src={`/flags/${currency.flag}.svg`} style={{ maxWidth: '50px', maxHeight: '50px' }} alt="" />
        </InputAdornment>
      }

      endAdornment={
        <InputAdornment position="end" style={{ paddingTop: '1.25rem', paddingRight: '1rem' }}>
          <IconButton>
            <IconArrowDropDown />
          </IconButton>
        </InputAdornment>
      }
    />
  </FormControl>
);

CurrencySelectField.propTypes = {
  id: PropTypes.string.isRequired,
  currency: PropTypes.instanceOf(Object).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(CurrencySelectField);



// WEBPACK FOOTER //
// ./src/components/calculator/currency-select/CurrencySelectField.js